import { HashRouter, Routes, Route } from "react-router-dom";
import { AxiosInterceptor } from "./config/index";
import routes from "./router";
import { useDispatch } from "react-redux";
import { Suspense } from "react";
const App = () => {
  const dispatch = useDispatch();
  // localStorage.setItem("token", "1a9ab2fc-de83-49a9-afc1-01615c02e0d7");
  return (
    <HashRouter>
      <AxiosInterceptor>
        <Routes>
          {routes.map((route, index) => {
            return (
              <Route
                path={route.path}
                key={index}
                element={
                  <Suspense>
                    <route.component
                      routes={route.children ? route.children : []}
                    />
                  </Suspense>
                }
              ></Route>
            );
          })}
        </Routes>
      </AxiosInterceptor>
    </HashRouter>
  );
};

export default App;
